export default "https://statics.cloudfastin.top/static/v1.27.31/store/images/shareloading.png?8fced9cecf1b12d30e0864ca7520667a";